import { DropdownSelectListCombinedProps } from './types';

const usePresenter = (props: DropdownSelectListCombinedProps): DropdownSelectListCombinedProps => {
  return props;
};

export default usePresenter;
